<script lang="ts">
import type { ThemeSlots } from '../types';
import { tv } from 'tailwind-variants';

const emptyClasses = tv({
	slots: {
		root: 'flex flex-col items-center justify-center gap-6 p-6',
		icon: 'flex size-14 items-center justify-center rounded-lg border border-default text-muted',
		title: 'text-center text-lg font-semibold',
		description: 'text-center text-sm text-muted',
		action: '',
	},
});
</script>

<script lang="ts" setup>
import { computed } from 'vue';

const { actionButtonIcon = 'lucide:plus' } = defineProps<{
	icon?: string;
	title?: string;
	description?: string;
	actionButtonLabel?: string;
	actionButtonIcon?: string;
	ui?: ThemeSlots<typeof emptyClasses>;
}>();

defineEmits<{
	action: [];
}>();

const theme = computed(() => emptyClasses());
</script>

<template>
	<div :class="theme.root({ class: ui?.root })">
		<div
			v-if="icon || $slots.illustration"
			:class="theme.icon({ class: ui?.icon })"
		>
			<slot name="illustration">
				<DIcon
					:name="icon"
					class="size-6"
				/>
			</slot>
		</div>

		<div
			v-if="title || description"
			class="flex flex-col items-center justify-between gap-1"
		>
			<div
				v-if="title"
				:class="theme.title({ class: ui?.title })"
			>
				{{ title }}
			</div>
			<div
				v-if="description"
				:class="theme.description({ class: ui?.description })"
			>
				{{ description }}
			</div>
		</div>

		<slot name="action" />

		<div
			v-if="actionButtonLabel && !$slots.action"
			:class="theme.action({ class: ui?.action })"
		>
			<DButton
				:icon="actionButtonIcon"
				variant="outline"
				color="neutral"
				size="sm"
				:label="actionButtonLabel"
				@click="$emit('action')"
			/>
		</div>
	</div>
</template>
